var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidden(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.697,
    height: 16.435,
    viewBox: "0 0 22.697 16.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Password_icon_2",
    "data-name": "Password icon 2",
    transform: "translate(0 0.773) rotate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M259.355,402l1.819-1.819a9.955,9.955,0,0,0-1.559-.13c-3.891,0-7.356,2.255-9.615,5.769a14.038,14.038,0,0,0,2.564,2.971l3.231-3.231A3.824,3.824,0,0,1,259.355,402Z",
    transform: "translate(-250 -399.019)",
    fill: "#0F1643"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M557.353,296l1.545-1.511-1.6-1.567-14.425,14.1,1.6,1.567,2.073-2.027a12.023,12.023,0,0,0,4.339.841c4.587,0,8.67-2.6,11.333-6.649A15.456,15.456,0,0,0,557.353,296Zm-6.468,9.191a4.523,4.523,0,0,1-2.3-.622l1.36-1.33a2.688,2.688,0,0,0,3.655-2.48,2.518,2.518,0,0,0-.184-.914l1.36-1.33a4.277,4.277,0,0,1,.637,2.244A4.484,4.484,0,0,1,550.885,305.189Z",
    transform: "translate(-540.055 -292.92)",
    fill: "#0F1643"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/hidden.cdd695aa5c34588a9a6e68a4ecb3384c.svg";
export { ForwardRef as ReactComponent };